import {EDebtPaymentType} from 'src/containers/Licenses/PaymentTab/definitions';

const INIT_LICENSE_PREFIX =
  'Activation of the license to use edna Pulse with the connection of the channel';
const RENEWAL_LICENSE_PREFIX =
  'Renewal of the license to use edna Pulse with the connection of the channel';
const LICENSE_INIT_PAYMENT_TD = 'License activation';

export default {
  paymentDebtsTitle: 'You have an overdue payment of',
  nextPaymentsTitle:
    'Upcoming fees in <strong>{{month}} {{year}}</strong> The preliminary amount is',
  th: {
    createdAt: 'Expired status effective date',
    blockedAt: 'Will be blocked on',
    paymentType: 'Payment type',
    total: 'Amount',
    paymentDate: 'Payment date',
    expireAt: 'Must pay before',
  },
  item: {
    [EDebtPaymentType.WHATSAPP_LICENSE_INIT_PAYMENT]: `Activation of the license to use edna Pulse with WHATSAPP channel connection (MAU {{mauCount}}){{account}}{{number}}, {{month}} {{year}}.`,
    [EDebtPaymentType.WHATSAPP_LICENSE_RENEWAL_PAYMENT]: `Renewal of the license to use edna Pulse with WHATSAPP channel connection (MAU {{mauCount}}){{account}}{{number}}, {{month}} {{year}}.`,
    [EDebtPaymentType.SMS_LICENSE_INIT_PAYMENT]: `${INIT_LICENSE_PREFIX} SMS, {{month}} {{year}}`,
    [EDebtPaymentType.SMS_LICENSE_RENEWAL_PAYMENT]: `${RENEWAL_LICENSE_PREFIX} SMS, {{month}} {{year}}`,
    [EDebtPaymentType.MAX_BOT_LICENSE_INIT_PAYMENT]: `${INIT_LICENSE_PREFIX} MAX Bot{{account}}{{number}}, {{month}} {{year}}`,
    [EDebtPaymentType.MAX_BOT_LICENSE_RENEWAL_PAYMENT]: `${RENEWAL_LICENSE_PREFIX} MAX Bot{{account}}{{number}}, {{month}} {{year}}`,
    [EDebtPaymentType.MAX_LICENSE_INIT_PAYMENT]: `${INIT_LICENSE_PREFIX} MAX{{account}}{{number}}, {{month}} {{year}}`,
    [EDebtPaymentType.MAX_LICENSE_RENEWAL_PAYMENT]: `${RENEWAL_LICENSE_PREFIX} MAX{{account}}{{number}}, {{month}} {{year}}`,
    [EDebtPaymentType.TELEGRAM_LICENSE_INIT_PAYMENT]: `${INIT_LICENSE_PREFIX} Telegram{{account}}{{number}}, {{month}} {{year}}`,
    [EDebtPaymentType.TELEGRAM_LICENSE_RENEWAL_PAYMENT]: `${RENEWAL_LICENSE_PREFIX} Telegram{{account}}{{number}}, {{month}} {{year}}`,
    [EDebtPaymentType.VIBER_LICENSE_INIT_PAYMENT]: `${INIT_LICENSE_PREFIX} VIBER, {{month}} {{year}}`,
    [EDebtPaymentType.VIBER_LICENSE_RENEWAL_PAYMENT]: `${RENEWAL_LICENSE_PREFIX} VIBER, {{month}} {{year}}`,
    [EDebtPaymentType.VIBER_RECURRENT_PAYMENT]: `Viber minimum fee over the period of {{month}} {{year}}{{account}}.`,
    [EDebtPaymentType.WHATSAPP_AMAU_PAYMENT]: `Message routing services via edna Pulse{{account}}{{number}}. AMAU`,
    [EDebtPaymentType.SMS_RECURRENT_BILLED]: `The subscription fee for using an alphanumeric signature ({{subject}}, operator «{{mobileOperator}}») for the {{month}} {{year}}.`,
    [EDebtPaymentType.SMS_TEMPLATE_BILLED]: `Operator SMS template fee ({{templateName}} for sender {{subject}}, operator «{{mobileOperator}}») for {{month}} {{year}}.`,
  },
  nextPaymentItem: {
    [EDebtPaymentType.WHATSAPP_LICENSE_INIT_PAYMENT]: `License activation, {{number}} {{month}} {{year}}.`,
    [EDebtPaymentType.WHATSAPP_LICENSE_RENEWAL_PAYMENT]: `Renewal of the license to use edna Pulse with WHATSAPP channel connection (MAU {{mauCount}}){{account}}{{number}}, {{month}} {{year}}.`,
    [EDebtPaymentType.SMS_LICENSE_INIT_PAYMENT]: `${INIT_LICENSE_PREFIX} SMS, {{month}} {{year}}`,
    [EDebtPaymentType.SMS_LICENSE_RENEWAL_PAYMENT]: `${RENEWAL_LICENSE_PREFIX} SMS, {{month}} {{year}}`,
    [EDebtPaymentType.MAX_BOT_LICENSE_INIT_PAYMENT]: `${INIT_LICENSE_PREFIX} MAX Bot{{account}}, {{month}} {{year}}`,
    [EDebtPaymentType.MAX_BOT_LICENSE_RENEWAL_PAYMENT]: `${RENEWAL_LICENSE_PREFIX} MAX Bot{{account}}, {{month}} {{year}}`,
    [EDebtPaymentType.MAX_LICENSE_INIT_PAYMENT]: `${INIT_LICENSE_PREFIX} MAX{{account}}, {{month}} {{year}}`,
    [EDebtPaymentType.MAX_LICENSE_RENEWAL_PAYMENT]: `${RENEWAL_LICENSE_PREFIX} MAX{{account}}, {{month}} {{year}}`,
    [EDebtPaymentType.TELEGRAM_LICENSE_INIT_PAYMENT]: `${INIT_LICENSE_PREFIX} Telegram{{account}}, {{month}} {{year}}`,
    [EDebtPaymentType.TELEGRAM_LICENSE_RENEWAL_PAYMENT]: `${RENEWAL_LICENSE_PREFIX} Telegram{{account}}, {{month}} {{year}}`,
    [EDebtPaymentType.VIBER_LICENSE_INIT_PAYMENT]: `${INIT_LICENSE_PREFIX} VIBER, {{month}} {{year}}`,
    [EDebtPaymentType.VIBER_LICENSE_RENEWAL_PAYMENT]: `${RENEWAL_LICENSE_PREFIX} VIBER, {{month}} {{year}}`,
    [EDebtPaymentType.VIBER_RECURRENT_PAYMENT]: `Viber minimum fee over the period of {{month}} {{year}}{{account}}.`,
    [EDebtPaymentType.WHATSAPP_AMAU_PAYMENT]: `Message routing services via edna Pulse{{account}}{{number}}. AMAU`,
    [EDebtPaymentType.SMS_RECURRENT_BILLED]: `The subscription fee for using an alphanumeric signature ({{subject}}, operator «{{mobileOperator}}») for the {{month}} {{year}}.`,
    [EDebtPaymentType.SMS_TEMPLATE_BILLED]: `Operator SMS template fee ({{templateName}} for sender {{subject}}, operator «{{mobileOperator}}») for {{month}} {{year}}.`,
  },
  collapseTd: {
    [EDebtPaymentType.WHATSAPP_LICENSE_INIT_PAYMENT]: LICENSE_INIT_PAYMENT_TD,
    [EDebtPaymentType.VIBER_LICENSE_INIT_PAYMENT]: LICENSE_INIT_PAYMENT_TD,
    [EDebtPaymentType.SMS_LICENSE_INIT_PAYMENT]: LICENSE_INIT_PAYMENT_TD,
    [EDebtPaymentType.MAX_BOT_LICENSE_INIT_PAYMENT]: LICENSE_INIT_PAYMENT_TD,
    [EDebtPaymentType.MAX_LICENSE_INIT_PAYMENT]: LICENSE_INIT_PAYMENT_TD,
    [EDebtPaymentType.TELEGRAM_LICENSE_INIT_PAYMENT]: LICENSE_INIT_PAYMENT_TD,
    [EDebtPaymentType.WHATSAPP_LICENSE_RENEWAL_PAYMENT]: 'WhatsApp License renewal',
    [EDebtPaymentType.SMS_LICENSE_RENEWAL_PAYMENT]: 'SMS License renewal',
    [EDebtPaymentType.VIBER_LICENSE_RENEWAL_PAYMENT]: 'Viber License renewal',
    [EDebtPaymentType.MAX_BOT_LICENSE_RENEWAL_PAYMENT]: 'MAX Bot License renewal',
    [EDebtPaymentType.MAX_LICENSE_RENEWAL_PAYMENT]: 'MAX License renewal',
    [EDebtPaymentType.TELEGRAM_LICENSE_RENEWAL_PAYMENT]: 'Telegram License renewal',
    [EDebtPaymentType.WHATSAPP_AMAU_PAYMENT]: `Message routing services`,
    [EDebtPaymentType.SMS_RECURRENT_BILLED]: `Subscription fee for the use of signatures in SMS`,
    [EDebtPaymentType.SMS_TEMPLATE_BILLED]: `Fee for operator SMS templates`,
    [EDebtPaymentType.VIBER_RECURRENT_PAYMENT]: `Subscription fee for the use of signatures in VIBER`,
  },
  hint: {
    blockedAtHint: 'After that, your account and interface will be locked beyond recovery',
    createdAtHint:
      'Before that date, the balance sheet was insufficient to pay the debt. Sending messages in this channel is not possible',
    expireAtHint:
      'If by this date the available balance is insufficient to write off, the license will be blocked and sending messages in the channel will become impossible',
    nextPaymentTotalHint:
      'The amount is preliminary. It depends on the variable part of the license and other non-fixed fees. The exact amount will be known on {{date}}',
    initPaymentTotalHint: 'The amount will appear when activating the license',
    amauPaymentTotalHint:
      'The amount depends on the number of messages sent over the license (AMAU)',
  },
};
